import { useState, useEffect } from 'react';

const MAX_WIDTH_NOT_MOBILE = 900;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MAX_WIDTH_NOT_MOBILE);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MAX_WIDTH_NOT_MOBILE);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}

export default useIsMobile;
